// extracted by mini-css-extract-plugin
module.exports = {"disabled":"DisabledOpacity_disabled__2UOMs","stripes":"DisabledOpacity_stripes__1Tln8","cover":"DisabledOpacity_cover__3JHph","wrapper":"DisabledOpacity_wrapper__1FYJe"};